new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img, #product-photo video');


                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }

            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.clickThumbs();

        let descriptionAcordeon = document.querySelector('.description-acordeon');
        if (descriptionAcordeon) {
            let navTab = descriptionAcordeon.querySelectorAll('.nav-item');
            let navShow = descriptionAcordeon.querySelectorAll('.description-acordeon-content');
            navTab = Array.from(navTab);
            navShow = Array.from(navShow);

            if (navTab.length && navShow.length) {
                function toggleTab(index) {
                    const isActive = navTab[index].classList.contains('active');

                    // remove todas as classes active
                    navTab.forEach((content) => content.classList.remove('active'));
                    navShow.forEach((content) => content.classList.remove('active'));

                    // se não estava ativo, ativa
                    if (!isActive) {
                        navTab[index].classList.add('active');
                        navShow[index].classList.add('active');
                    }
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        toggleTab(index);
                    });
                });
            }
        }

        let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = Array.from(description.querySelectorAll('.nav-item'));
            let navShow = Array.from(description.querySelectorAll('.description-nav-content'));

            function toggleTab(index) {
                const isActive = navTab[index].classList.contains('active');

                // Remove todos os ativos
                navTab.forEach(item => item.classList.remove('active'));
                navShow.forEach(content => content.classList.remove('active'));

                // Se não estava ativo, ativa o novo
                if (!isActive) {
                    navTab[index].classList.add('active');
                    navShow[index].classList.add('active');
                }
            }

            navTab.forEach((item, index) => {
                item.addEventListener('click', () => toggleTab(index));
            });
        }

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    if ($('.carrousel-photos').length) {
        let $carousel = $('.carrousel-photos');
        let $counter = $('.count-images');

        // Inicializa o slick
        $carousel.on('init', function (event, slick) {
            $counter.text(`1/${slick.slideCount}`);
        });

        $carousel.on('afterChange', function (event, slick, currentSlide) {
            $counter.text(`${currentSlide + 1}/${slick.slideCount}`);
        });

        $carousel.slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.icon-arrow-left'),
            nextArrow: $('.icon-arrow-right'),
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 100,
            vertical: false,
        });
    }

    if ($('.product-detail__header--photoArea-mobile')) {
        $('.product-detail__header--photoArea-mobile').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            speed: 100,
            vertical: false,
        });
    }

    const description = document.querySelector('.description');
    if (description) {
        let secondBlock = document.querySelectorAll('.description .second-block');
        if (secondBlock.length) {
            secondBlock.forEach((item) => {
                let btn = item.querySelector('.second-block-content-btn');
                btn.textContent = 'COMPRAR'
            })
        }
    }

    const buttons = document.querySelectorAll('.second-block-content-btn');
    const targetElement = document.querySelector('.product-detail__header--infoArea');
    if (targetElement && buttons) {
        buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault(); // Evita o redirecionamento padrão da tag <a>
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth' // Transição suave
                });
            });
        });
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(() => {
        const CONTAINER_SELECTOR = '#js_buy_together_api_layout_1_groups';
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_SELECTOR = '[id^="js_buy_together_api_group_"]';
        const CHECKBOX_SELECTOR = '.checkbox-together-selectable';
        const VARIATION_SELECTOR = '.product-radio-variation input[type="radio"], .product-item__options select';

        const container = document.querySelector(CONTAINER_SELECTOR);

        if (!container) return;

        const selectedGroups = new Set();

        const getLayout = () => {
            return container.closest('#js_buy_together_api_layout_1');
        };

        const getGroups = () => {
            return Array.from(
                container.querySelectorAll(GROUP_SELECTOR)
            );
        };

        const canSelectProducts = () => {
            return getLayout()?.classList.contains(
                'allow-select-products'
            ) === true;
        };

        const isMasterGroup = group => {
            return (
                group.dataset.isMasterGroup === 'true' ||
                group.id === 'js_buy_together_api_group_0'
            );
        };

        /*
         * Verifica se o produto possui variações.
         *
         * Se não existir radio/select de variação,
         * o produto é considerado simples.
         */
        const hasVariations = group => {
            return !!group.querySelector(VARIATION_SELECTOR);
        };

        /*
         * Define se o produto participa da compra.
         */
        const isRequiredGroup = group => {
            // Compre junto normal: todos obrigatórios
            if (!canSelectProducts()) {
                return true;
            }

            // Produto principal: sempre obrigatório
            if (isMasterGroup(group)) {
                return true;
            }

            // Produtos opcionais: dependem do checkbox
            const checkbox = group.querySelector(
                CHECKBOX_SELECTOR
            );

            return checkbox?.checked === true;
        };

        /*
         * Verifica se o produto está pronto.
         *
         * Produto simples:
         * não precisa selecionar tamanho.
         *
         * Produto com variações:
         * precisa de seleção.
         */
        const isGroupSelected = group => {
            if (!hasVariations(group)) {
                return true;
            }

            return selectedGroups.has(group.id);
        };

        /*
         * Numeração sempre aberta abaixo do nome (layout da broganv3):
         * o .product-item__options sai da foto para a .info-product.
         */
        const initializeSizeOptions = group => {
            /*
             * O bloco chega por AJAX depois do lazy-load da página:
             * carrega as fotos (inclusive a 2ª, do mouseover).
             */
            group.querySelectorAll('img[data-src]').forEach(img => {
                img.setAttribute('src', img.getAttribute('data-src'));
                img.removeAttribute('data-src');
            });

            if (group.dataset.sizeOptionsBound === '1') return;

            const infoProduct = group.querySelector('.info-product');
            const options = group.querySelector('.product-item__options');

            if (!infoProduct || !options || !group.querySelector('.product-radio-variation')) return;

            group.dataset.sizeOptionsBound = '1';

            if (options.parentElement !== infoProduct) {
                infoProduct.appendChild(options);
            }

            options.classList.add('buy-together-size-options');
        };

        /*
         * Atualiza please-select e botão.
         */
        const syncUI = () => {
            const groups = getGroups();

            groups.forEach(initializeSizeOptions);

            const addCartBtn = document.querySelector(
                ADD_CART_BTN_SELECTOR
            );

            if (!addCartBtn) return;

            const requiredGroups = [];

            groups.forEach(group => {
                const required = isRequiredGroup(group);
                const selected = isGroupSelected(group);

                /*
                 * Produto não participa da compra:
                 * remove please-select.
                 */
                if (!required) {
                    group.classList.remove('please-select');
                    return;
                }

                requiredGroups.push(group);

                /*
                 * Produto simples:
                 * nunca precisa de please-select.
                 *
                 * Produto com variações:
                 * exige seleção do usuário.
                 */
                group.classList.toggle(
                    'please-select',
                    hasVariations(group) && !selected
                );
            });

            /*
             * Todos os produtos obrigatórios
             * precisam estar prontos.
             *
             * Produtos simples já são válidos.
             */
            const allSelected =
                requiredGroups.length > 0 &&
                requiredGroups.every(group => {
                    return isGroupSelected(group);
                });

            addCartBtn.classList.toggle(
                'no-buy',
                !allSelected
            );
        };

        /*
         * Registra seleção de variação.
         */
        const markSelected = group => {
            if (!group?.id) return;

            if (!isRequiredGroup(group)) return;

            // Produto simples não precisa registrar seleção
            if (!hasVariations(group)) return;

            selectedGroups.add(group.id);

            group.classList.remove('please-select');

            syncUI();
        };

        /*
         * CHANGE
         */
        container.addEventListener('change', event => {
            const target = event.target;

            if (!(target instanceof Element)) return;

            const group = target.closest(GROUP_SELECTOR);

            if (!group) return;

            /*
             * Checkbox de inclusão do produto.
             */
            if (target.matches(CHECKBOX_SELECTOR)) {
                if (
                    canSelectProducts() &&
                    isMasterGroup(group)
                ) {
                    return;
                }

                if (
                    canSelectProducts() &&
                    !target.checked
                ) {
                    selectedGroups.delete(group.id);
                    group.classList.remove('please-select');
                }

                syncUI();

                return;
            }

            /*
             * Radio de variação.
             */
            if (target.matches('input[type="radio"]')) {
                markSelected(group);
                return;
            }

            /*
             * Select de variação.
             */
            if (target.matches('select')) {
                markSelected(group);
            }
        });

        /*
         * CLICK EM LABEL
         *
         * Fallback para radios customizados.
         */
        container.addEventListener('click', event => {
            const target = event.target;

            if (!(target instanceof Element)) return;

            // Checkbox não é seleção de tamanho
            if (target.closest('.checkbox-together')) {
                return;
            }

            const label = target.closest('label');

            if (!label) return;

            const group = label.closest(GROUP_SELECTOR);

            if (!group) return;

            if (!isRequiredGroup(group)) return;

            // Produto simples não precisa de interação
            if (!hasVariations(group)) return;

            setTimeout(() => {
                markSelected(group);
            }, 0);
        });

        /*
         * Observa produtos adicionados ou substituídos.
         */
        const observer = new MutationObserver(mutations => {
            const changed = mutations.some(mutation => {
                return mutation.type === 'childList';
            });

            if (!changed) return;

            const groups = getGroups();

            const existingIds = new Set(
                groups.map(group => group.id)
            );

            selectedGroups.forEach(groupId => {
                if (!existingIds.has(groupId)) {
                    selectedGroups.delete(groupId);
                }
            });

            syncUI();
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });

        syncUI();
    });

    if ($('#like-carousel')) {
        $('#like-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1680,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    }

});

/**
 * Modal da galeria de fotos do produto.
 * Substitui o fancybox, que escrevia hash na URL e quebrava a navegação.
 * Os links da galeria usam data-gallery="nome-do-grupo".
 */
(function () {
    const YOUTUBE_REGEX = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/;
    const VIDEO_REGEX = /\.(mp4|webm|ogg|mov)(\?.*)?$/i;

    const MAX_ZOOM = 8;
    const DOUBLE_CLICK_ZOOM = 3;
    const DOUBLE_TAP_DELAY = 300;

    let modal = null;
    let slider = null;
    let counter = null;
    let prevArrow = null;
    let nextArrow = null;

    const zoomStates = new WeakMap();
    let drag = null;
    let gesture = null;
    let lastTap = null;

    function youtubeSlide(id) {
        return `<div class="gallery-modal__slide"><iframe src="https://www.youtube.com/embed/${id}?rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    }

    function videoSlide(src) {
        return `<div class="gallery-modal__slide"><video controls playsinline><source src="${src}"></video></div>`;
    }

    function buildSlide(item) {
        const src = item.src;

        // no cadastro do YouTube o campo guarda só o ID, não a URL completa
        if (item.type === 'youtube') {
            const match = src.match(YOUTUBE_REGEX);
            return youtubeSlide(match ? match[1] : src);
        }

        if (item.type === 'video') return videoSlide(src);

        const youtube = src.match(YOUTUBE_REGEX);
        if (youtube) return youtubeSlide(youtube[1]);

        if (VIDEO_REGEX.test(src)) return videoSlide(src);

        return `<div class="gallery-modal__slide"><div class="gallery-modal__zoom"><img src="${src}" alt="" draggable="false"></div></div>`;
    }

    function buildModal() {
        modal = document.createElement('div');
        modal.className = 'gallery-modal';
        modal.innerHTML = `
            <div class="gallery-modal__backdrop" data-gallery-close></div>
            <div class="gallery-modal__content">
                <span class="gallery-modal__counter"></span>
                <button type="button" class="gallery-modal__close" aria-label="Fechar" data-gallery-close>
                    <svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>
                </button>
                <button type="button" class="gallery-modal__arrow gallery-modal__arrow--prev" aria-label="Anterior">
                    <svg viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"/></svg>
                </button>
                <div class="gallery-modal__slider"></div>
                <button type="button" class="gallery-modal__arrow gallery-modal__arrow--next" aria-label="Próximo">
                    <svg viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"/></svg>
                </button>
            </div>
        `;
        document.body.appendChild(modal);

        slider = modal.querySelector('.gallery-modal__slider');
        counter = modal.querySelector('.gallery-modal__counter');
        prevArrow = modal.querySelector('.gallery-modal__arrow--prev');
        nextArrow = modal.querySelector('.gallery-modal__arrow--next');

        modal.addEventListener('click', function (e) {
            if (e.target.closest('[data-gallery-close]')) {
                closeModal();
            }
        });

        prevArrow.addEventListener('click', () => $(slider).slick('slickPrev'));
        nextArrow.addEventListener('click', () => $(slider).slick('slickNext'));

        document.addEventListener('keydown', function (e) {
            if (!modal.classList.contains('is-open')) return;

            if (e.key === 'Escape') closeModal();
            if (e.key === 'ArrowLeft') $(slider).slick('slickPrev');
            if (e.key === 'ArrowRight') $(slider).slick('slickNext');
        });

        bindZoom();
    }

    /* ----------------------------------------------------------------------
     * Zoom das imagens
     * Os handlers rodam na fase de captura porque o slick escuta o swipe em
     * .slick-list (filho do slider): só assim dá para engolir o gesto antes
     * dele virar troca de slide quando a foto está ampliada.
     * -------------------------------------------------------------------- */

    function zoomStateOf(zoom) {
        let state = zoomStates.get(zoom);

        if (!state) {
            state = { scale: 1, x: 0, y: 0 };
            zoomStates.set(zoom, state);
        }

        return state;
    }

    function applyZoom(zoom) {
        const state = zoomStateOf(zoom);
        const img = zoom.querySelector('img');
        if (!img) return;

        // sem deixar a foto escapar da moldura: o excedente é metade para cada lado
        const limitX = Math.max(0, (img.offsetWidth * state.scale - zoom.clientWidth) / 2);
        const limitY = Math.max(0, (img.offsetHeight * state.scale - zoom.clientHeight) / 2);

        state.x = Math.min(limitX, Math.max(-limitX, state.x));
        state.y = Math.min(limitY, Math.max(-limitY, state.y));

        img.style.transform = `translate3d(${state.x}px, ${state.y}px, 0) scale(${state.scale})`;
        zoom.classList.toggle('is-zoomed', state.scale > 1);
    }

    function originOf(zoom, clientX, clientY) {
        const rect = zoom.getBoundingClientRect();

        return {
            x: clientX - rect.left - rect.width / 2,
            y: clientY - rect.top - rect.height / 2
        };
    }

    function zoomTo(zoom, scale, originX, originY) {
        const state = zoomStateOf(zoom);
        const next = Math.min(MAX_ZOOM, Math.max(1, scale));
        const ratio = next / state.scale;

        // o ponto sob o cursor/dedo continua sob o cursor/dedo depois do zoom
        state.x = originX - (originX - state.x) * ratio;
        state.y = originY - (originY - state.y) * ratio;
        state.scale = next;

        if (next === 1) {
            state.x = 0;
            state.y = 0;
        }

        applyZoom(zoom);
    }

    function resetZoom(zoom) {
        const state = zoomStateOf(zoom);

        state.scale = 1;
        state.x = 0;
        state.y = 0;

        applyZoom(zoom);
    }

    // a transição só entra nos saltos (duplo clique/toque); no arrasto ela atrasaria a imagem
    function animateZoom(zoom) {
        zoom.classList.add('is-smooth');
        setTimeout(() => zoom.classList.remove('is-smooth'), 220);
    }

    function toggleZoom(zoom, clientX, clientY) {
        const origin = originOf(zoom, clientX, clientY);

        animateZoom(zoom);

        if (zoomStateOf(zoom).scale > 1) {
            resetZoom(zoom);
        } else {
            zoomTo(zoom, DOUBLE_CLICK_ZOOM, origin.x, origin.y);
        }
    }

    function zoomOf(e) {
        return e.target.closest ? e.target.closest('.gallery-modal__zoom') : null;
    }

    function touchDistance(touches) {
        return Math.hypot(
            touches[0].clientX - touches[1].clientX,
            touches[0].clientY - touches[1].clientY
        );
    }

    function touchMidpoint(touches) {
        return {
            x: (touches[0].clientX + touches[1].clientX) / 2,
            y: (touches[0].clientY + touches[1].clientY) / 2
        };
    }

    function bindZoom() {
        slider.addEventListener('wheel', onWheel, { capture: true, passive: false });
        slider.addEventListener('dblclick', onDoubleClick, true);
        slider.addEventListener('mousedown', onMouseDown, true);
        slider.addEventListener('touchstart', onTouchStart, { capture: true, passive: false });
        slider.addEventListener('touchmove', onTouchMove, { capture: true, passive: false });
        slider.addEventListener('touchend', onTouchEnd, { capture: true, passive: false });
    }

    function onWheel(e) {
        const zoom = zoomOf(e);
        if (!zoom) return;

        e.preventDefault();
        e.stopPropagation();

        const origin = originOf(zoom, e.clientX, e.clientY);
        // exponencial para a sensação ser a mesma perto de 1x e perto de 8x
        const factor = Math.exp(-e.deltaY * 0.0015);

        zoomTo(zoom, zoomStateOf(zoom).scale * factor, origin.x, origin.y);
    }

    function onDoubleClick(e) {
        const zoom = zoomOf(e);
        if (!zoom) return;

        e.preventDefault();
        e.stopPropagation();

        toggleZoom(zoom, e.clientX, e.clientY);
    }

    function onMouseDown(e) {
        const zoom = zoomOf(e);
        if (!zoom || zoomStateOf(zoom).scale <= 1) return;

        // sem zoom o arrasto pertence ao slick; ampliado ele passa a mover a foto
        e.preventDefault();
        e.stopPropagation();

        drag = { zoom, x: e.clientX, y: e.clientY };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }

    function onMouseMove(e) {
        if (!drag) return;

        const state = zoomStateOf(drag.zoom);

        state.x += e.clientX - drag.x;
        state.y += e.clientY - drag.y;
        drag.x = e.clientX;
        drag.y = e.clientY;

        applyZoom(drag.zoom);
    }

    function onMouseUp() {
        drag = null;

        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    }

    function onTouchStart(e) {
        const zoom = zoomOf(e);
        if (!zoom) return;

        if (e.touches.length === 2) {
            e.stopPropagation();

            const mid = touchMidpoint(e.touches);

            gesture = {
                zoom,
                mode: 'pinch',
                distance: touchDistance(e.touches),
                x: mid.x,
                y: mid.y
            };

            return;
        }

        if (e.touches.length === 1 && zoomStateOf(zoom).scale > 1) {
            e.stopPropagation();

            gesture = { zoom, mode: 'pan', x: e.touches[0].clientX, y: e.touches[0].clientY };
        }
    }

    function onTouchMove(e) {
        if (!gesture) return;

        const state = zoomStateOf(gesture.zoom);

        if (gesture.mode === 'pinch' && e.touches.length === 2) {
            e.preventDefault();
            e.stopPropagation();

            const mid = touchMidpoint(e.touches);
            const distance = touchDistance(e.touches);
            const origin = originOf(gesture.zoom, mid.x, mid.y);

            // arrastar os dois dedos junto também desloca a foto
            state.x += mid.x - gesture.x;
            state.y += mid.y - gesture.y;

            zoomTo(gesture.zoom, state.scale * (distance / gesture.distance), origin.x, origin.y);

            gesture.distance = distance;
            gesture.x = mid.x;
            gesture.y = mid.y;

            return;
        }

        if (gesture.mode === 'pan' && e.touches.length === 1) {
            e.preventDefault();
            e.stopPropagation();

            state.x += e.touches[0].clientX - gesture.x;
            state.y += e.touches[0].clientY - gesture.y;
            gesture.x = e.touches[0].clientX;
            gesture.y = e.touches[0].clientY;

            applyZoom(gesture.zoom);
        }
    }

    function onTouchEnd(e) {
        if (gesture) {
            // tirou um dedo do pinça: o que sobrou continua arrastando a foto
            if (e.touches.length === 1 && gesture.mode === 'pinch') {
                e.stopPropagation();

                gesture = {
                    zoom: gesture.zoom,
                    mode: 'pan',
                    x: e.touches[0].clientX,
                    y: e.touches[0].clientY
                };

                return;
            }

            if (e.touches.length > 0) return;

            const wasPinch = gesture.mode === 'pinch';
            gesture = null;

            // a pinça não é candidata a duplo toque
            if (wasPinch) {
                lastTap = null;
                return;
            }
        }

        const zoom = zoomOf(e);
        const point = e.changedTouches[0];
        if (!zoom || !point) return;

        const now = Date.now();
        const isDoubleTap = lastTap
            && now - lastTap.time < DOUBLE_TAP_DELAY
            && Math.abs(point.clientX - lastTap.x) < 30
            && Math.abs(point.clientY - lastTap.y) < 30;

        if (isDoubleTap) {
            // sem o preventDefault o navegador ainda sintetizaria o clique/dblclick do toque
            e.preventDefault();
            e.stopPropagation();

            toggleZoom(zoom, point.clientX, point.clientY);
            lastTap = null;
            return;
        }

        lastTap = { time: now, x: point.clientX, y: point.clientY };
    }

    function updateStatus(current, total) {
        counter.textContent = `${current + 1} / ${total}`;
        prevArrow.disabled = current === 0;
        nextArrow.disabled = current === total - 1;
    }

    function openModal(items, index) {
        if (!modal) buildModal();

        slider.innerHTML = items.map(buildSlide).join('');

        modal.classList.add('is-open');
        document.body.classList.add('gallery-modal-open');

        $(slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            speed: 300,
            initialSlide: index,
            adaptiveHeight: false,
        });

        $(slider).on('afterChange', function (event, slick, currentSlide) {
            // pausa qualquer vídeo que ficou para trás
            slider.querySelectorAll('video').forEach(video => video.pause());
            // a foto que ficou para trás volta ao tamanho normal
            slider.querySelectorAll('.gallery-modal__zoom').forEach(resetZoom);
            updateStatus(currentSlide, items.length);
        });

        updateStatus(index, items.length);
    }

    function closeModal() {
        if (!modal) return;

        modal.classList.remove('is-open');
        document.body.classList.remove('gallery-modal-open');

        drag = null;
        gesture = null;
        lastTap = null;

        if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('unslick');
        }

        // limpar o conteúdo interrompe vídeos e iframes que estavam tocando
        slider.innerHTML = '';
    }

    function sourceOf(element) {
        return element.getAttribute('href') || element.getAttribute('data-gallery-src');
    }

    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-gallery]');
        if (!trigger) return;

        // os vídeos entram na galeria, mas tocam na própria página:
        // só os links (imagens) abrem o modal
        if (!trigger.getAttribute('href')) return;

        e.preventDefault();

        const group = trigger.getAttribute('data-gallery');
        // o slick duplica slides quando é infinito; os clones não podem entrar na lista
        const members = Array.from(document.querySelectorAll(`[data-gallery="${group}"]`))
            .filter(item => sourceOf(item) && !item.closest('.slick-cloned'));

        const items = members.map(item => ({
            src: sourceOf(item),
            type: item.getAttribute('data-gallery-type') || ''
        }));

        let index = members.indexOf(trigger);
        if (index < 0) {
            // clicou num clone: localiza pela imagem correspondente
            index = Math.max(items.findIndex(item => item.src === sourceOf(trigger)), 0);
        }

        if (items.length) openModal(items, index);
    });
})();